import {BaseDto} from 'common';

/**
 * reflects SubscriptionPaymentDto dto on server
 */
export class SubscriptionPaymentDto extends BaseDto {
    amount: number;
    paymentDate: number;
    endDate: number;
    discount: number;
    trial: boolean;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
